import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";
import { Venue } from "../../../model/Venue";

export const UPDATE_VENUE = "UPDATE_VENUE";

export interface UpdateVenueAction extends Action {
  type: "UPDATE_VENUE";
  id: number;
  data: Partial<Venue>;
  files: File[];
  logo: File | null | undefined;
  organization: OrganizationKeyName;
}

export const updateVenueAction = (
  organization: OrganizationKeyName,
  id: number,
  data: Partial<Venue>,
  files: File[],
  logo: File | null | undefined
): UpdateVenueAction => ({
  type: UPDATE_VENUE,
  id,
  data,
  files,
  organization,
  logo,
});
